import React, { useState, useEffect } from 'react';
import { CheckCircle, User, Phone, MapPin, MessageSquare, Calendar, Users, Shield, Globe, Truck, Building2, AlertTriangle, Send } from 'lucide-react';
import { handleAddComplain } from '../../api/complain';
import { getborders } from "../../api/border";
import 'bootstrap/dist/css/bootstrap.min.css';

function ComplainForm() {
    const [loading, setLoading] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [borderDatas, setBorderDatas] = useState([]);
    const [formData, setFormData] = useState({
        fullName: '',
        mobileNumber: '',
        age: '',
        gender: '',
        borderName: '',
        complain: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (event) => {
        if (event) event.preventDefault();
        setLoading(true);
        
        console.log('Form Submitted:', formData);
        
        const ComplainData = {
            fullName: formData.fullName,
            mobileNumber: formData.mobileNumber,
            age: formData.age,
            gender: formData.gender,
            borderName: formData.borderName,
            complain: formData.complain,
        };
        
        handleAddComplain(ComplainData, (result) => {
            setLoading(false);
            if (result.ok !== 1) {
                console.log(result);
                alert("Error submitting complaint. Please try again.");
                return;
            }
            
            // Show success animation
            setIsSubmitted(true);
            
            // Reset form after 3 seconds
            setTimeout(() => {
                setIsSubmitted(false);
                setFormData({
                    fullName: '',
                    mobileNumber: '',
                    age: '',
                    gender: '',
                    borderName: '',
                    complain: '',
                });
            }, 3000);
        });
    };

    useEffect(() => {
        setLoading(true);
        getborders((result) => {
            if (result.ok === 1) {
                setBorderDatas(result.result);
            }
            setLoading(false);
        });
    }, []);

    // Modern Hero Illustration
    const ModernHeroSection = () => (
        <div className="hero-section position-relative overflow-hidden rounded-4 bg-primary mb-5 p-4 p-md-5">
            <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-20"></div>
            
            {/* Animated background elements */}
            <div className="position-absolute top-0 start-0 w-100 h-100">
                <div className="floating-element element-1 position-absolute bg-primary bg-opacity-20 rounded-circle blur-xl"></div>
                <div className="floating-element element-2 position-absolute bg-purple bg-opacity-20 rounded-circle blur-xl"></div>
                <div className="floating-element element-3 position-absolute bg-info bg-opacity-20 rounded-circle blur-xl"></div>
            </div>
            
            {/* Content */}
            <div className="position-relative z-10 text-center text-white">
                
                
                <h1 className="hero-title mb-3 fw-bold">
                    EABC Trade Report Portal
                </h1>
                <p className="hero-subtitle mb-4 mx-auto">
                    Secure, confidential reporting system for border trade issues, complaints, and whistleblowing incidents across East African borders
                </p>
                
                {/* Stats */}
                
            </div>
        </div>
    );

    // Success Animation Component
    const SuccessAnimation = () => (
        <div className="modal-backdrop show d-flex align-items-center justify-content-center p-3">
            <div className="success-modal bg-white rounded-4 shadow-lg text-center w-100 max-w-md overflow-hidden">
                {/* Header */}
                <div className="success-header bg-success p-4 p-md-5 text-white">
                    <div className="success-icon-container mx-auto mb-3">
                        <CheckCircle className="success-icon text-white" />
                    </div>
                    <h3 className="success-title fw-bold mb-0">Success!</h3>
                </div>
                
                {/* Content */}
                <div className="success-content p-4 p-md-5">
                    <h4 className="success-subtitle text-dark mb-3 fw-semibold">Report Submitted Successfully</h4>
                    <p className="success-message text-muted mb-4">
                        Your complaint has been received and assigned a tracking ID. Our team will review your report and contact you soon.
                    </p>
                    
                    <div className="processing-indicator bg-light rounded-3 p-3">
                        <div className="d-flex align-items-center justify-content-center">
                            <div className="processing-dot me-2"></div>
                            <span className="processing-text text-success fw-medium">Processing your report...</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    // Loading Component
    const LoadingSpinner = () => (
        <div className="d-flex align-items-center justify-content-center">
            <div className="spinner-dots d-flex me-3">
                <div className="spinner-dot"></div>
                <div className="spinner-dot"></div>
                <div className="spinner-dot"></div>
            </div>
            <span className="loading-text fw-medium">Submitting Report...</span>
        </div>
    );

    return (
        <div className="complain-form-wrapper min-vh-100 bg-light">
            {/* Custom CSS */}
            <style jsx>{`
                .complain-form-wrapper {
                    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 50%, #dee2e6 100%);
                }

                .hero-section {
                    background: linear-gradient(135deg, #2c3e50 0%, #3498db 50%, #9b59b6 100%) !important;
                }

                .logo-icon {
                    width: 80px;
                    height: 80px;
                    backdrop-filter: blur(10px);
                    transition: transform 0.3s ease;
                }

                .logo-icon:hover {
                    transform: scale(1.1);
                }

                .badge-icon {
                    width: 24px;
                    height: 24px;
                    top: -8px;
                    right: -8px;
                }

                .hero-title {
                    font-size: 2.5rem;
                    letter-spacing: -0.5px;
                }

                .hero-subtitle {
                    font-size: 1.1rem;
                    opacity: 0.9;
                    max-width: 600px;
                }

                .stat-card {
                    backdrop-filter: blur(10px);
                    border: 1px solid rgba(255,255,255,0.1);
                    transition: transform 0.3s ease;
                }

                .stat-card:hover {
                    transform: translateY(-5px);
                }

                .stat-icon {
                    width: 24px;
                    height: 24px;
                }

                .stat-value {
                    font-size: 1.1rem;
                }

                .stat-label {
                    font-size: 0.8rem;
                    opacity: 0.8;
                }

                .form-container {
                    backdrop-filter: blur(10px);
                    border: 1px solid rgba(255,255,255,0.2);
                    box-shadow: 0 20px 40px rgba(0,0,0,0.1);
                }

                .form-section {
                    margin-bottom: 2rem;
                }

                .form-field {
                    transition: all 0.3s ease;
                    border: 2px solid transparent;
                    background: linear-gradient(135deg, #f8f9fa, #e9ecef);
                }

                .form-field:hover {
                    border-color: #007bff;
                    transform: translateY(-2px);
                    box-shadow: 0 5px 15px rgba(0,0,0,0.1);
                }

                .form-field:focus-within {
                    border-color: #007bff;
                    transform: translateY(-2px);
                    box-shadow: 0 8px 25px rgba(0,123,255,0.15);
                }

                .field-icon {
                    transition: transform 0.3s ease;
                }

                .form-field:focus-within .field-icon {
                    transform: scale(1.1) rotate(5deg);
                }

                .submit-btn {
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    border: none;
                    transition: all 0.3s ease;
                    position: relative;
                    overflow: hidden;
                }

                .submit-btn:hover:not(:disabled) {
                    transform: translateY(-3px);
                    box-shadow: 0 10px 25px rgba(102, 126, 234, 0.4);
                }

                .submit-btn:disabled {
                    opacity: 0.7;
                    cursor: not-allowed;
                }

                .floating-element {
                    animation: float 6s ease-in-out infinite;
                }

                .element-1 {
                    width: 80px;
                    height: 80px;
                    top: 10%;
                    left: 10%;
                    animation-delay: 0s;
                }

                .element-2 {
                    width: 120px;
                    height: 120px;
                    top: 20%;
                    right: 15%;
                    animation-delay: 2s;
                }

                .element-3 {
                    width: 100px;
                    height: 100px;
                    bottom: 15%;
                    left: 20%;
                    animation-delay: 4s;
                }

                .icon-large {
                    width: 40px;
                    height: 40px;
                }

                .icon-small {
                    width: 12px;
                    height: 12px;
                }

                .success-icon {
                    width: 60px;
                    height: 60px;
                }

                .success-icon-container {
                    width: 80px;
                    height: 80px;
                    background: rgba(255,255,255,0.2);
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    animation: bounce 2s infinite;
                }

                .processing-dot {
                    width: 8px;
                    height: 8px;
                    background: #28a745;
                    border-radius: 50%;
                    animation: pulse 1.5s infinite;
                }

                .spinner-dot {
                    width: 12px;
                    height: 12px;
                    background: white;
                    border-radius: 50%;
                    animation: bounce 1.4s infinite;
                }

                .spinner-dot:nth-child(2) {
                    animation-delay: 0.2s;
                }

                .spinner-dot:nth-child(3) {
                    animation-delay: 0.4s;
                }

                .modal-backdrop {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: rgba(0,0,0,0.8);
                    backdrop-filter: blur(5px);
                    z-index: 1050;
                }

                @keyframes float {
                    0%, 100% { transform: translateY(0px) rotate(0deg); }
                    50% { transform: translateY(-20px) rotate(5deg); }
                }

                @keyframes bounce {
                    0%, 100% { transform: scale(1); }
                    50% { transform: scale(1.1); }
                }

                @keyframes pulse {
                    0%, 100% { opacity: 1; transform: scale(1); }
                    50% { opacity: 0.5; transform: scale(0.8); }
                }

                .max-w-md {
                    max-width: 400px;
                }

                @media (max-width: 768px) {
                    .hero-title {
                        font-size: 2rem;
                    }
                    
                    .hero-subtitle {
                        font-size: 1rem;
                    }
                    
                    .logo-icon {
                        width: 60px;
                        height: 60px;
                    }
                    
                    .icon-large {
                        width: 30px;
                        height: 30px;
                    }
                }
            `}</style>

            <div className="container py-4">
                <ModernHeroSection />
                
                <div className="form-container bg-white bg-opacity-90 rounded-4 shadow-lg p-4 p-md-5">
                    <form onSubmit={handleSubmit}>
                        <div className="row g-4">
                            {/* Personal Information Section */}
                            <div className="col-12 form-section">
                                <div className="d-flex align-items-center mb-4">
                                    <div className="section-icon bg-primary rounded-2 d-flex align-items-center justify-content-center me-3">
                                        <User className="text-white" />
                                    </div>
                                    <h2 className="section-title text-dark mb-0 fw-bold">Personal Information</h2>
                                </div>
                                
                                <div className="row g-4">
                                    <div className="col-md-6">
                                        <div className="form-field rounded-3 p-3">
                                            <label className="form-label d-flex align-items-center text-dark mb-2 fw-semibold">
                                                <User className="field-icon text-primary me-2" />
                                                Full Name
                                                <span className="text-danger ms-1">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                name="fullName"
                                                placeholder="Enter your complete legal name"
                                                className="form-control border-0 bg-transparent px-2 py-2"
                                                value={formData.fullName}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-field rounded-3 p-3">
                                            <label className="form-label d-flex align-items-center text-dark mb-2 fw-semibold">
                                                <Phone className="field-icon text-success me-2" />
                                                Mobile Number
                                                <span className="text-danger ms-1">*</span>
                                            </label>
                                            <input
                                                type="tel"
                                                name="mobileNumber"
                                                placeholder="+255 XXX XXX XXX"
                                                className="form-control border-0 bg-transparent px-2 py-2"
                                                value={formData.mobileNumber}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Demographics Section */}
                            <div className="col-12 form-section">
                                <div className="d-flex align-items-center mb-4">
                                    <div className="section-icon bg-purple rounded-2 d-flex align-items-center justify-content-center me-3">
                                        <Users className="text-white" />
                                    </div>
                                    <h2 className="section-title text-dark mb-0 fw-bold">Demographics</h2>
                                </div>
                                
                                <div className="row g-4">
                                    <div className="col-md-6">
                                        <div className="form-field rounded-3 p-3">
                                            <label className="form-label d-flex align-items-center text-dark mb-2 fw-semibold">
                                                <Calendar className="field-icon text-purple me-2" />
                                                Age Group
                                                <span className="text-danger ms-1">*</span>
                                            </label>
                                            <select
                                                name="age"
                                                className="form-select border-0 bg-transparent px-2 py-2"
                                                value={formData.age}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="">Select your age group</option>
                                                <option value="below_35">Below 35 years</option>
                                                <option value="above_35">Above 35 years</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-field rounded-3 p-3">
                                            <label className="form-label d-flex align-items-center text-dark mb-2 fw-semibold">
                                                <Users className="field-icon text-pink me-2" />
                                                Gender
                                                <span className="text-danger ms-1">*</span>
                                            </label>
                                            <select
                                                name="gender"
                                                className="form-select border-0 bg-transparent px-2 py-2"
                                                value={formData.gender}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="">Select gender</option>
                                                <option value="male">Male</option>
                                                <option value="female">Female</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Location & Report Section */}
                            <div className="col-12 form-section">
                                <div className="d-flex align-items-center mb-4">
                                    <div className="section-icon bg-danger rounded-2 d-flex align-items-center justify-content-center me-3">
                                        <MapPin className="text-white" />
                                    </div>
                                    <h2 className="section-title text-dark mb-0 fw-bold">Location & Report Details</h2>
                                </div>
                                
                                <div className="row g-4">
                                    <div className="col-12">
                                        <div className="form-field rounded-3 p-3">
                                            <label className="form-label d-flex align-items-center text-dark mb-2 fw-semibold">
                                                <MapPin className="field-icon text-danger me-2" />
                                                Border Checkpoint
                                                <span className="text-danger ms-1">*</span>
                                            </label>
                                            <select
                                                name="borderName"
                                                className="form-select border-0 bg-transparent px-2 py-2"
                                                value={formData.borderName}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="">Select border checkpoint</option>
                                                {borderDatas.map((item, index) => (
                                                    <option key={index} value={item.name}>
                                                        {item.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="form-field rounded-3 p-3">
                                            <label className="form-label d-flex align-items-center text-dark mb-2 fw-semibold">
                                                <MessageSquare className="field-icon text-warning me-2" />
                                                Detailed Report / Complaint
                                                <span className="text-danger ms-1">*</span>
                                            </label>
                                            
                                            <textarea
                                                name="complain"
                                                rows="5"
                                                placeholder="Describe your complaint, issue, or incident in detail. Include dates, times, people involved, and any other relevant information..."
                                                className="form-control border-0 bg-transparent px-2 py-2"
                                                value={formData.complain}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Submit Button */}
                            <div className="col-12">
                                <button
                                    type="submit"
                                    disabled={loading}
                                    className="submit-btn w-100 text-white fw-bold py-3 rounded-3"
                                >
                                    {loading ? (
                                        <LoadingSpinner />
                                    ) : (
                                        <span className="d-flex align-items-center justify-content-center">
                                            <Send className="me-2" />
                                            Submit Confidential Report
                                        </span>
                                    )}
                                </button>
                            </div>
                        </div>
                    </form>

                    {/* Footer Info */}
                    <div className="row g-3 mt-4">
                        <div className="col-md-6">
                            <div className="info-card bg-light rounded-3 p-3 border">
                                <div className="d-flex align-items-start">
                                    <Shield className="text-primary me-3 mt-1 flex-shrink-0" />
                                    <div>
                                        <h6 className="fw-semibold text-dark mb-1">Confidential & Secure</h6>
                                        <p className="text-muted small mb-0">
                                            Your identity and report are protected with end-to-end encryption and handled with strict confidentiality.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="col-md-6">
                            <div className="info-card bg-light rounded-3 p-3 border">
                                <div className="d-flex align-items-start">
                                    <Globe className="text-success me-3 mt-1 flex-shrink-0" />
                                    <div>
                                        <h6 className="fw-semibold text-dark mb-1">Improving Trade</h6>
                                        <p className="text-muted small mb-0">
                                            Your reports help us improve cross-border trade experiences and ensure fair treatment for all traders.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Success Modal */}
            {isSubmitted && <SuccessAnimation />}
        </div>
    );
}

export default ComplainForm;